import { forwardRef, Input } from '@chakra-ui/react'
import React from 'react'

const BaseInput = forwardRef(({ control, editors, label, ...props }, ref) => (
  <Input
    color="gray.700"
    bg="gray.50"
    border="none"
    size="md"
    rounded="md"
    focusBorderColor="teal.600"
    overflowX="scroll"
    h="auto"
    py="2"
    _placeholder={{ color: 'gray.300' }}
    {...props}
    ref={ref}
  />
))

export default BaseInput
